import { render, staticRenderFns } from "./ProjectServiceReport.vue?vue&type=template&id=0a5ca05a&scoped=true"
import script from "./ProjectServiceReport.vue?vue&type=script&lang=js"
export * from "./ProjectServiceReport.vue?vue&type=script&lang=js"
import style0 from "./ProjectServiceReport.vue?vue&type=style&index=0&id=0a5ca05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5ca05a",
  null
  
)

export default component.exports